import React, { useContext, useState } from "react";
import { PopupContext, TableContext } from "../../index";
import { CardTypes } from "../UserCardService";
import { showSuccessToast } from "../../validation/ToastContainer";
import { deleteCentralCredential } from "../authService";
import { getDeletePopup } from "../../view/popup/PopupContainer";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { MoreVertical, Edit2, Trash2 } from 'lucide-react';

function CentralCredentialsTableRow({ data, index }) {

    const { config, setConfig } = useContext(TableContext);
    const { setPopup } = useContext(PopupContext);

    // MUI Menu state
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onEditClick = () => {
        handleClose();
        config.showModal({ cardType: CardTypes.EDIT, centralCredentialsId: data.id });
    };

    const onDeleteClick = () => {
        handleClose();

        setPopup(getDeletePopup(`Are you sure you want to delete username: ${data.username} ?`, "Delete Central Credentials", () => {
            deleteCentralCredential(data.id).then(() => {
                showSuccessToast("Central Credentials deleted", "Delete Central Credentials");
                setConfig({ ...config, lastUpdated: Date.now() });
            })
        }, undefined, "Delete Credentials"));

    };

    return (
        <tr key={index}>
            <td>{data.ccname}</td>
            <td>{data.username}</td>
            <td>{'*'.repeat(data.password.length)}</td>
            <td>
                <button className="oct_dropdown-trigger-v2" onClick={handleClick}>
                    <MoreVertical className="oct_icon" />
                </button>

                <Menu
                    className="oct_menu-v2"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}>

                    <MenuItem className="oct_menu-item-v2" onClick={onEditClick}>
                        <Edit2 className="oct_icon" /> Edit
                    </MenuItem>
                    <MenuItem className="oct_menu-item-v2 oct_menu-item-danger" onClick={onDeleteClick}>
                        <Trash2 className="oct_icon" /> Delete
                    </MenuItem>

                </Menu>
            </td>
        </tr>
    );

}

export default CentralCredentialsTableRow;
